import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Partner} from "../../../../../classes/partner";
import {Note} from "../../../../../classes/note";

@Component({
    selector: 'kan-notes-list',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class kanNotesList {
    @Input() public notes: Note[];
    @Input() public searchText: string;
    @Input() public loading: boolean = false;
    @Output() public refresh: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    ngOnInit(): void {
    }

    public emitRefresh(): void {
        this.refresh.emit();
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/notes/list/component.ts